export const JOBS_GET_JOB_BY_ID = 'jobsGetJob';
export const BRAND_GET_BRAND_BY_ID = 'brandGetBrandById';
export const EVENT_GET_FREE_APPOINTMENTS_BY_EVENT_ID = 'getFreeAppointmentsByEventId';
export const BRAND_GET_SERVICEABLE_BRANDS = 'brandGetServiceableBrands';
export const BRAND_GET_DELIVERY_POINTS_BY_BRAND_ID = 'brandsGetDeliveryPointsByBrandId';
export const TMXSTORE_GET_STORE_BY_ID = 'tmxStoreGetStoreById';
